var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointSystemLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "point_bg",
    d: "M44 22.5C44 34.6503 34.1503 44.5 22 44.5C9.84974 44.5 0 34.6503 0 22.5C0 10.3497 9.84974 0.5 22 0.5C34.1503 0.5 44 10.3497 44 22.5Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "point_text",
    d: "M12.5714 35.8571H17.7221V26.6792H22.0027C28.3018 26.6792 33 23.9572 33 18.0945C33 12.0224 28.3714 9.92857 21.8287 9.92857H12.5714V35.8571ZM17.7221 22.5962V14.0464H21.4459C25.622 14.0464 27.9886 15.0236 27.9886 18.0945C27.9886 21.1306 25.8309 22.5962 21.6199 22.5962H17.7221Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointSystemLogo);
export default __webpack_public_path__ + "static/media/point_system_logo.b34d8bec330554d2d1868ce2b5b1bd14.svg";
export { ForwardRef as ReactComponent };